<template>
<v-layout class="fullpage">
  	
  	<v-toolbar>
  		<v-btn icon 
          class=""
          @click="$router.push('/')">
          <v-icon class="grey--text text--darken-2">keyboard_backspace</v-icon>
        </v-btn>
	    <v-toolbar-title>
	      INTERACTIVE FLOORPLANS STATS
	    </v-toolbar-title>

  	</v-toolbar>

    <v-container>  
    	<span class="headline pb-3" v-if="uniqueVisitors" v-html="uniqueVisitors + ' Unique Vistors'"> Unique Visitors</span>
    	<v-layout>
		    <v-dialog
		        ref="dialog1"
		        v-model="modal1"
		        :return-value.sync="startDate"
		        persistent
		        lazy
		        full-width
		        width="290px">
		        <v-text-field
			        slot="activator"
			        v-model="startDate"
			        label="Start Date"
			        prepend-icon="event"
			        single-line
			        readonly/>
		        <v-date-picker v-model="startDate" @change="getStats('dialog1', startDate)" scrollable />
	      	</v-dialog>

	      	<v-dialog
		        ref="dialog2"
		        v-model="modal2"
		        :return-value.sync="endDate"
		        persistent
		        lazy
		        full-width
		        width="290px">
		        <v-text-field class="ml-5"
			        slot="activator"
			        v-model="endDate"
			        label="End Date"
			        prepend-icon="event"
			        single-line
			        readonly/>
		        <v-date-picker v-model="endDate" @change="getStats('dialog2', endDate)" scrollable />
	      	</v-dialog>
  		</v-layout>

  		<GChart class="mb-5 mt-3" v-if="chartData.length > 0" style="height: 300px;"
		    type="ColumnChart"
		    :data="chartData"
		    :options="chartOptions"
		/>

	    <v-card>
			<v-data-table
				v-if="startDate && stats.length < 1000"
				class="statsTable mb-5"
				item-key="date" 
				:headers="headers" 
				:loading="loading"
				:items="stats" 
				no-data-text=""
				hide-actions>
				<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>							
				<template slot="items" slot-scope="props">
						<tr :id="props.item.key" :active="props.selected">
							<td class="caption rt-td" v-for="header in headers">
								{{ props.item[header.value] }} {{ (header.value == 'user' && !props.item[header.value]) ? '( ' + props.item['netID'] + " )" : ""}}
							</td>
						</tr>
				</template>

			</v-data-table>
		</v-card>
	</v-container>

</v-layout>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import jscookie from 'js-cookie'
import { GChart } from 'vue-google-charts'

export default {
	components: { GChart },
	name: 'Stats',
		data() {
			return {
				headers : [
						{ text: 'Name',             value: 'user',                },
						{ text: 'College',          value: 'collegeName',                },
						{ text: 'Department',       value: 'department',          },
						{ text: 'Title',           	value: 'title',               },
						{ text: 'Date',         	value: 'date',            	  },						
        			],
        		startDate : null,
        		endDate: null,
        		modal1: false,
        		modal2: false,
        		loading: false,
        		chartData: [],
		    	chartOptions: {
			        chart: {
			          title: 'Unique Visitors',
			          subtitle: 'Date, Visitors',			          
			        },
			        chartArea:{left:50,top:20, width: "100%" }
			    }
         	}
		},

    computed: {
    	...mapState({
        	stats: state => state.ui.stats,
      	}),

    	uniqueVisitors() {
			let list = this.stats.map(row => row.netID);
			list = list.filter((value, index) => { return list.indexOf(value) == index; });
			list.sort()
			//console.log(list)
			return list.length
		}
    },

	methods: {
		...mapActions(['fetchStats', 'fetchStatsDailyUnique']),
		...mapMutations(['setStats']),

		getStats(ref, date) {
			this.$refs[ref].save(date)
			if (!this.startDate || !this.endDate) { return }
			
			this.loading = true
			//let payload = { startDate: this.startDate, endDate: this.endDate ? this.endDate : this.startDate }
			let payload = { startDate: this.startDate, endDate: this.endDate }
			this.fetchStats(payload).then((data) => {
				this.setStats(data)
				this.loading = false
			})

			this.fetchStatsDailyUnique(payload).then((data) => {
				this.formatChartData(data)
				this.loading = false
			})
		},

		formatChartData(data) {
			this.chartData = [['Date', 'Visitors']]

			data.forEach(row => {
				let dateProto = row.date.replace('T', '').replace(/-/g,'/');
				let dateElement = new Date(row.date);
				let newRow = [ dateElement, row.uniqueUsers]
				this.chartData.push(newRow)
			})

			console.log(this.chartData)
		}



		
	},
}
</script>

<style>
  .fullpage {
    display: absolute;
    flex-direction: column;
    flex: 1;
    z-index: 100000;
    position: fixed;
    top: 0px;
    width: 100vw;
    background-color: rgba(255, 255, 255, 0.8);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0px;
    padding-top: 0px;
    margin-top: 0px;
    height: 100%;
  }

  .statsTable {
  	/*height: 70vh;*/
  	height: calc(100vh - 600px) !important; 
	overflow-y: auto;
  }

  .statsTable td {
  	height: auto !important;
  }

  .statsTable .table__overflow { 
	overflow-x: unset !important;
	overflow-y: unset !important;
 }

</style>


// WEBPACK FOOTER //
// src/components/Stats.vue